import React, { useEffect } from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import Article from "../../../../entities/article";
import PortalPCArticleBox from "./PortalPCArticleBox";

type Props = {
  company_name: string;
  company_name_ja: string;
};

function PortalPCArticleList({ company_name, company_name_ja }: Props) {
  const { results, sort } = ArticleSearchContainer.useContainer();

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("react_rendering"));
  }, [results]);

  if (!results || results.length === 0) {
    return (
      <p className="portalNotFoundMessage">
        条件に当てはまる募集は見つかりませんでした。
      </p>
    );
  }

  const renderCards = (articles: any[]) =>
    articles.map((article) => (
      <PortalPCArticleBox
        key={article.id}
        article={new Article(article)}
        company_name={company_name}
        company_name_ja={company_name_ja}
      />
    ));

  // NOTE: ピックアップ分離はおすすめ順(sort未指定)のときだけ
  if (sort !== "") {
    return (
      <>
        <h2 className="portalArticleListHeading">募集一覧</h2>
        <div className="portalArticleList">{renderCards(results)}</div>
      </>
    );
  }

  const pickups = results.filter((article: any) => article.pickup);
  const others = results.filter((article: any) => !article.pickup);

  return (
    <>
      {pickups.length > 0 && (
        <>
          <h2 className="portalArticleListHeading">ピックアップボランティア</h2>
          <div className="portalArticleList">{renderCards(pickups)}</div>
        </>
      )}
      <h2 className="portalArticleListHeading">募集一覧</h2>
      <div className="portalArticleList">{renderCards(others)}</div>
    </>
  );
}

export default PortalPCArticleList;
